import React, { useState, useEffect } from 'react';
import { useStyles } from './sectionEngines.jss';
import { Chip, FormControlLabel, Box, Checkbox } from '@material-ui/core';
import CheckBox from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import Clear from '@material-ui/icons/Clear';
import { useSelector } from 'react-redux';

function SectionEngines({
  translations: { engines, mainText, noElectricsFound },
  onEngineTypeChange,
  isElectricExist
}) {
  const classes = useStyles();
  const { electricChecked } = useSelector((state) => state.carBooking);
  const [electricEngine, setElectricEngine] = useState(false);
  const [electricExist, setElectricExist] = useState(false);

  const changeEngineType = (onlyElectric) => {
    setElectricEngine(onlyElectric);
    onEngineTypeChange(onlyElectric);
  };

  useEffect(() => {
    setElectricExist(isElectricExist);
    if (!isElectricExist) setElectricEngine(isElectricExist);
  }, [isElectricExist]);

  return (
    <>
      <Box className={classes.filterCheckbox} pt={2} pb={2} mt={4} mb={4}>
        <FormControlLabel
          classes={{
            root: classes.root,
            label: classes.labelBox
          }}
          control={
            <Checkbox
              checked={electricChecked ? true : electricEngine}
              onChange={(event) => changeEngineType(event.target.checked)}
              name="electric"
              classes={{
                root: classes.checkbox,
                checked: classes.checked
              }}
              color="primary"
              disabled={!isElectricExist}
              icon={
                electricExist ? (
                  <CheckBoxOutlineBlank
                    classes={{
                      root: classes.iconRoot
                    }}
                    fontSize="small"
                  />
                ) : (
                  <Clear
                    classes={{
                      root: classes.iconRoot
                    }}
                    fontSize="small"
                  />
                )
              }
              checkedIcon={
                <CheckBox
                  classes={{
                    root: classes.iconRoot
                  }}
                  fontSize="small"
                />
              }
            />
          }
          label={
            <div className={classes.labelBox}>
              <span className={classes.filterCheckboxText}>
                {electricExist ? mainText : noElectricsFound}
              </span>
              <div>
                {electricExist &&
                  engines.map((engine) => (
                    <Chip
                      key={engine}
                      className={classes.chipCheckbox}
                      label={engine}
                      variant="outlined"
                    />
                  ))}
              </div>
            </div>
          }
        />
      </Box>
    </>
  );
}

export default SectionEngines;
